/** YAML workspace on-disk schema constants. */

export const WORKSPACE_MANIFEST = 'apiboo.yaml';
/**
 * The `*.local.yaml` rule is what keeps values of variables marked `secret`
 * out of the repository (COL-06). It used to be aspirational: it named files
 * the serializer never wrote, while the secrets themselves went into the
 * TRACKED `variables/*.yaml` and `environments/*.yaml` that `git_commit_all`
 * stages with `add_all(["*"])`. `serialize.js` now actually writes the
 * sidecars listed below, so the rule covers real files.
 */
export const LEGACY_GITIGNORE_TEMPLATE = `# Apiboo local secrets (do not commit)
# Values of variables marked "secret" live here, never in the tracked YAML:
#   variables/globals.local.yaml
#   variables/workspace.local.yaml
#   environments/<name>.local.yaml
secrets.local.yaml
*.local.yaml
`;

/**
 * Since 01.10.2026 (git sync Stage 1, card 5) Apiboo owns ONE marked block in
 * `.gitignore` and `.gitattributes` instead of the whole file: the user's own
 * lines around it are kept (the old template overwrote the file on every
 * flush). `mergeManagedBlock` puts the block in; a file that is exactly the
 * legacy template is replaced, so existing repos don't get it twice.
 */
export const BLOCK_BEGIN = '# >>> Apiboo — managed block (your own lines outside it are kept)';
export const BLOCK_END = '# <<< Apiboo';

export const GITIGNORE_TEMPLATE = `${BLOCK_BEGIN}
# Values of variables marked "secret" live in *.local.yaml, never in tracked YAML.
*.local.yaml
secrets.local.yaml
${BLOCK_END}
`;

/** LF in the repo whatever the OS — same bytes from every machine. */
export const GITATTRIBUTES_TEMPLATE = `${BLOCK_BEGIN}
*.yaml text eol=lf
${BLOCK_END}
`;

/**
 * `existing` (the file on disk, or null) with Apiboo's block put in: replaced
 * where it already is, appended once when it is not, the whole file when it is
 * missing or still the legacy template. Lines outside the block never change.
 */
export function mergeManagedBlock(existing, block) {
  if (existing == null || existing === '' || existing === LEGACY_GITIGNORE_TEMPLATE) return block;
  const text = existing.replace(/\r\n/g, '\n');
  const start = text.indexOf(BLOCK_BEGIN);
  const end = start >= 0 ? text.indexOf(BLOCK_END, start) : -1;
  if (start >= 0 && end >= 0) {
    const after = text.indexOf('\n', end);
    return text.slice(0, start) + block + (after >= 0 ? text.slice(after + 1) : '');
  }
  return `${text}${text.endsWith('\n') ? '' : '\n'}\n${block}`;
}

export const SCHEMA_VERSION = 1;

/** Runtime-only fields stripped before YAML persist. */
export const RUNTIME_COLLECTION_FIELDS = new Set([
  '_deviceLocal',
  '_localWorkspaceId',
  '_localWorkspaceName',
]);

export const RUNTIME_REQUEST_FIELDS = new Set([]);
